module.exports = "https://static.wmbcdn.com/uniweb/images/9669f949c95ce0c6c3d79366c94cd141.svg";